<template>
    <v-app>
        <template>
            <v-card
                class=" overflow-hidden"
                height="100%"
                tile
            >

                <v-app-bar
                    color="blue-grey darken-4"
                    dark
                >
                    <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>

                    <v-toolbar-title>COVID-19 <span class="caption">(SARS-CoV-2)</span></v-toolbar-title>
                </v-app-bar>

                <v-navigation-drawer
                    v-model="drawer"
                    absolute
                    temporary
                >

                    <v-list
                        nav
                        dense
                    >
                        <v-list-item-group
                            active-class="deep-purple--text text--accent-4"
                        >
                            <v-list-item-group color="primary">
                                <v-list-item
                                v-for="(item, i) in items"
                                :key="i"
                                >
                                    <v-list-item-icon>
                                        <v-icon v-text="item.icon"></v-icon>
                                    </v-list-item-icon>

                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <router-link :to="item.hrefer">
                                                {{ item.text }}
                                            </router-link>
                                        </v-list-item-title>
                                    </v-list-item-content>

                                </v-list-item>
                            </v-list-item-group>

                        </v-list-item-group>
                    </v-list>
                </v-navigation-drawer>
                    <v-container>
                        <router-view></router-view>
                    </v-container>
            </v-card>
        </template>
        <Footer />
    </v-app>
</template>

<script>

import Footer from './components/Footer.vue'

export default {
    components: {
        Footer
    },

    data: () => ({
        drawer: false,

        items: [
            { text: 'Главная', hrefer: '/', icon: 'mdi-home' },
            { text: 'Рекомендации', hrefer: '/recommendations', icon: 'mdi-flag' },
        ],
    }),
}
</script>

<style>
a{text-decoration: none !important; color: rgba(0, 0, 0, 0.87) !important;}
</style>